module.exports = __webpack_public_path__ + "img/en.0c8987c5.svg";